import { RecoveredDialog } from "../components/RecoveredDialog"

export const Recovered = () => {
    return <RecoveredDialog />
}
